import React, { Component } from 'react';
import { connect } from 'react-redux';
import { parse } from 'query-string';
import { object } from 'prop-types';
import { injectIntl } from 'react-intl';
import { streamConstants } from '../../constants/streams';
import {
  startSetStreamTDS,
  startSetStreams,
  startEditStreamTDS,
} from '../../actions/streams';
import Layout from '../../components/Layout/Layout';
import StreamTDSForm from '../../components/StreamTDS/StreamTDSForm/StreamTDSForm';
import WithAlert from '../../hoc/WithAlert';
import { iFMessage } from '../../hoc/IntlComponents';

class StreamTDSPage extends Component {
  static propTypes = {
    streamTDS: object.isRequired,
  };

  state = {
    loading: false,
  };

  componentDidMount() {
    const { match, history, intl } = this.props;
    const params = parse(history.location.search);
    const streamId = parseInt(match.params.id, 10);

    this.props.startSetStreams({ limit: 100 });

    if (params.created) {
      this.props.showAlert({
        alertType: 'success',
        message: iFMessage({intl, id: 'stream-tds.created-success'}),
        dismissable: false,
        closeInSeconds: 3,
      });
    }

    if (params.saved) {
      this.props.showAlert({
        alertType: 'success',
        message: iFMessage({intl, id: 'stream-tds.alert.saved'}),
        dismissable: false,
        closeInSeconds: 3,
      });
    }

    if (!isNaN(streamId)) {
      this.setState(() => ({ loading: true }));

      this.props
        .startSetStreamTDS(streamId)
        .then(({ type, stream = {} }) => {
          if (type === streamConstants.SET_STREAM_FAILURE) {
            this.props.history.replace('/404');
            return;
          }
        })
        .then(() => this.setState(() => ({ loading: false })))
        .catch(({ response }) => this.handleError(response));
    }
  }

  /**
   * Handle request error
   * @param {Object} response Error response
   */
  handleError = response => {
    if (response && response.data && response.data.error) {
      const { message: error } = response.data.error;
      this.props.showAlert({
        alertType: 'danger',
        message: error.message,
        dismissable: false,
        closeInSeconds: 5,
      });
    }
    this.setState(() => ({ loading: false }));
  };

  handleSubmit = (streamId, updates) => {
    this.setState(() => ({ loading: true }));

    this.props
      .startEditStreamTDS(streamId, updates)
      .then(() => this.props.history.replace(`/tools/streams/tds/${streamId}?saved=1`))
      .catch(({ response }) => this.handleError(response));
  };

  render() {
    const { loading } = this.state;
    const { streamTDS } = this.props;

    return (
      <Layout title={streamTDS.title}>
        <Layout.Col>
          <StreamTDSForm
            loading={loading}
            streamTDS={streamTDS}
            onSubmit={this.handleSubmit}
          />
        </Layout.Col>
      </Layout>
    );
  }
}

const mapStateToProps = ({ streams }) => ({
  streamTDS: streams.selected
});

const mapDispatchToProps = dispatch => ({
  startSetStreamTDS: streamId => dispatch(startSetStreamTDS(streamId)),
  startSetStreams: params => dispatch(startSetStreams(params)),
  startEditStreamTDS: (streamId, updates) => dispatch(startEditStreamTDS(streamId, updates)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithAlert(injectIntl(StreamTDSPage)));
